import {DrugItemDrawerMedicationProfilesSection} from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import {useActiveSubstanceDrugContext} from '@/shared/contexts/active-substance-drug'
import {Tabs} from '@chakra-ui/react'

export function MedicationProfilesTab() {
  const {activeSubstanceDrug} = useActiveSubstanceDrugContext()

  return (
    <Tabs.Content value="medication-profiles">
      <DrugItemDrawerMedicationProfilesSection drugItem={activeSubstanceDrug} />
    </Tabs.Content>
  )
}
